export function getCSS(uniqueId, userConnected, placeholderGallery) {
  const placeholderCrossSellGallerySize = 7;
  const CSS = [];
  let cssRules;
  const monitor = require('./images/monitor.jpg');
  const ring = require('./images/ring.jpg');
  const scooter = require('./images/scooter.jpg');
  const shoes = require('./images/shoes.jpg');
  const smartphone = require('./images/smartphone.jpg');
  const watch = require('./images/watch.jpg');
  const dress = require('./images/dress.jpg');

  // fill the gallery with fake listings
  if (placeholderGallery) {
    cssRules = `
      #${uniqueId}-image0 {
        background-image: url("${monitor}");
        background-size: cover;
      }
      #${uniqueId}-item-name0::after {
        content: 'Samsung C27F391 27" Curved VA LED FHD 1920x1080 4ms Monitor 1800R FreeSync VESA';
      }
      #${uniqueId}-item-price0::after {
        content: 'Buy it now: 299 USD';
      }
      #${uniqueId}-item-ends-in0::after {
        content: 'Ends in less than 3 days';
      }
      #${uniqueId}-image1 {
        background-image: url("${ring}");
        background-size: cover;
      }
      #${uniqueId}-item-name1::after {
        content: 'DIAMOND ROUND BRILLIANT RING 1 CT WEDDING 14 KT YELLOW GOLD ELEGANT SOLITAIRE';
      }
      #${uniqueId}-item-price1::after {
        content: 'Buy it now: 3150 USD';
      }
      #${uniqueId}-item-ends-in1::after {
        content: 'Ends in less than 10 days';
      }
      #${uniqueId}-image2 {
        background-image: url("${dress}");
        background-size: cover;
      }
      #${uniqueId}-item-name2::after {
        content: 'Eggplant Purple 100% Silk Mermaid Bridesmaid Dress';
      }
      #${uniqueId}-item-price2::after {
        content: 'Buy it now: 584 USD';
      }
      #${uniqueId}-item-ends-in2::after {
        content: 'Ends in less than 7 days';
      }
      #${uniqueId}-image3 {
        background-image: url("${shoes}");
        background-size: cover;
      }
      #${uniqueId}-item-name3::after {
        content: 'Nike Air Zoom Vomero 12 men running run sneakers shoes NEW blue';
      }
      #${uniqueId}-item-price3::after {
        content: 'Buy it now: 112.5 USD';
      }
      #${uniqueId}-item-ends-in3::after {
        content: 'Ends in less than 12 days';
      }
      #${uniqueId}-image4 {
        background-image: url("${smartphone}");
        background-size: cover;
      }
      #${uniqueId}-item-name4::after {
        content: 'New SEALED Apple iPhone 7 PLUS 256GB Rose Gold (T-Mobile) Clean IMEI! MetroPCS';
      }
      #${uniqueId}-item-price4::after {
        content: 'Buy it now: 870 USD';
      }
      #${uniqueId}-item-ends-in4::after {
        content: 'Ends in less than 5 days';
      }
      #${uniqueId}-image5 {
        background-image: url("${watch}");
        background-size: cover;
      }
      #${uniqueId}-item-name5::after {
        content: "Bulova Men's 98B152 Precisionist Rubber Strap Watch";
      }
      #${uniqueId}-item-price5::after {
        content: 'Buy it now: 239 USD';
      }
      #${uniqueId}-item-ends-in5::after {
        content: 'Ends in less than 2 days';
      }
      #${uniqueId}-image6 {
        background-image: url("${scooter}");
        background-size: cover;
      }
      #${uniqueId}-item-name6::after {
        content: 'Electric-Ride-On-Scooter-6-5-inch-2-Wheel';
      }
      #${uniqueId}-item-price6::after {
        content: 'Buy it now: 329 USD';
      }
      #${uniqueId}-item-ends-in6::after {
        content: 'Ends in less than 7 days';
      }
    `;
  } else if (userConnected) {
    cssRules = `
      .cross-sell-gallery-image-wrapper > .cross-sell-gallery-image {
        background-image: url("https://imgplaceholder.com/300x300?text=Loading+image&font-size=32&font-family=Roboto");
        background-size: contain;
      }
      `;
  } else {
    cssRules = `
      .cross-sell-gallery-image-wrapper > .cross-sell-gallery-image {
        background-image: url("https://imgplaceholder.com/300x300?text=Connect+your+eBay+account_br_to+view+products+images&font-size=20&font-family=Roboto");
      }
      `;
  }
  CSS.push(cssRules);

  // building placeholder cross sell gallery
  for (let i = 0; i < placeholderCrossSellGallerySize; i++) {
    let prevIndex = i - 1;
    if (i === 0) {
      prevIndex = placeholderCrossSellGallerySize - 1;
    }

    cssRules = `
    #${uniqueId}-input_${i}:checked ~ .cross-sell-gallery-wrapper .cross-sell-gallery-left-arrow-wrapper[for=${uniqueId}-input_${(i + 1) % placeholderCrossSellGallerySize}] {
      display: block;
    }
    #${uniqueId}-input_${i}:checked ~ .cross-sell-gallery-wrapper .cross-sell-gallery-right-arrow-wrapper[for=${uniqueId}-input_${prevIndex}] {
      display: block;
    }
    #${uniqueId}-input_${i}:checked ~ .cross-sell-gallery-wrapper .cross-sell-gallery-link .cross-sell-gallery-image-wrapper${prevIndex} {
      width: 5%;
      left: 50px;
      display: block;
      opacity: 0;
    }
      #${uniqueId}-input_${i}:checked ~ .cross-sell-gallery-wrapper .cross-sell-gallery-link .cross-sell-gallery-image-wrapper${i} {
      width: 10%;
      left: 50px;
      opacity: 0.5;
      display: block;
      box-shadow: 0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.12);
      z-index: 1;
    }
    #${uniqueId}-input_${i}:checked ~ .cross-sell-gallery-wrapper .cross-sell-gallery-link .cross-sell-gallery-image-wrapper${i}:hover {
      opacity: 1;
      box-shadow: 0 3px 10px rgba(0, 0, 0, 0.16), 0 3px 10px rgba(0, 0, 0, 0.23);
    }
    #${uniqueId}-input_${i}:checked ~ .cross-sell-gallery-wrapper .cross-sell-gallery-link .cross-sell-gallery-image-wrapper${(i + 1) % placeholderCrossSellGallerySize} {
      width: 16%;
      left: 19.43%;
      opacity: 0.8;
      display: block;
      box-shadow: 0 3px 10px rgba(0, 0, 0, 0.16), 0 3px 10px rgba(0, 0, 0, 0.23);
    }
    #${uniqueId}-input_${i}:checked ~ .cross-sell-gallery-wrapper .cross-sell-gallery-link .cross-sell-gallery-image-wrapper${(i + 1) % placeholderCrossSellGallerySize}:hover {
      opacity: 1;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.19), 0 6px 10px rgba(0, 0, 0, 0.23);
    }
    #${uniqueId}-input_${i}:checked ~ .cross-sell-gallery-wrapper .cross-sell-gallery-link .cross-sell-gallery-image-wrapper${(i + 2) % placeholderCrossSellGallerySize} {
      width: 20%;
      left: 39.63%;
      display: block;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.19), 0 6px 10px rgba(0, 0, 0, 0.23);
    }
    #${uniqueId}-input_${i}:checked ~ .cross-sell-gallery-wrapper .cross-sell-gallery-link .cross-sell-gallery-image-wrapper${(i + 2) % placeholderCrossSellGallerySize}:hover {
      box-shadow: 0 14px 45px rgba(0, 0, 0, 0.25), 0 10px 18px rgba(0, 0, 0, 0.22);
    }
    #${uniqueId}-input_${i}:checked ~ .cross-sell-gallery-wrapper .cross-sell-gallery-link .cross-sell-gallery-image-wrapper${(i + 3) % placeholderCrossSellGallerySize} {
      width: 16%;
      left: 64.57%;
      opacity: 0.8;
      display: block;
      box-shadow: 0 3px 10px rgba(0, 0, 0, 0.16), 0 3px 10px rgba(0, 0, 0, 0.23);
    }
    #${uniqueId}-input_${i}:checked ~ .cross-sell-gallery-wrapper .cross-sell-gallery-link .cross-sell-gallery-image-wrapper${(i + 3) % placeholderCrossSellGallerySize}:hover {
      opacity: 1;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.19), 0 6px 10px rgba(0, 0, 0, 0.23);
    }
    #${uniqueId}-input_${i}:checked ~ .cross-sell-gallery-wrapper .cross-sell-gallery-link .cross-sell-gallery-image-wrapper${(i + 4) % placeholderCrossSellGallerySize} {
      width: 10%;
      left: 84.77%;
      opacity: 0.5;
      display: block;
      box-shadow: 0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.12);
      z-index: 1;
    }
    #${uniqueId}-input_${i}:checked ~ .cross-sell-gallery-wrapper .cross-sell-gallery-link .cross-sell-gallery-image-wrapper${(i + 4) % placeholderCrossSellGallerySize}:hover {
      opacity: 1;
      box-shadow: 0 3px 10px rgba(0, 0, 0, 0.16), 0 3px 10px rgba(0, 0, 0, 0.23);
    }
    #${uniqueId}-input_${i}:checked ~ .cross-sell-gallery-wrapper .cross-sell-gallery-link .cross-sell-gallery-image-wrapper${(i + 5) % placeholderCrossSellGallerySize} {
      left: 84.77%;
      width: 5%;
      display: block;
      opacity: 0;
    }
    #${uniqueId}-input_${i}:checked ~ .mobile-cross-sell-gallery-wrapper .cross-sell-gallery-left-arrow-wrapper[for=${uniqueId}-input_${(i + 1) % placeholderCrossSellGallerySize}] {
      display: block;
     }
     #${uniqueId}-input_${i}:checked ~ .mobile-cross-sell-gallery-wrapper .cross-sell-gallery-right-arrow-wrapper[for=${uniqueId}-input_${prevIndex}] {
      display: block;
     }
    #${uniqueId}-input_${i}:checked ~ .mobile-cross-sell-gallery-wrapper .cross-sell-gallery-image-wrapper${prevIndex} {
      left: -175%;
      display: block;
      opacity: 0;
    }
    #${uniqueId}-input_${i}:checked ~ .mobile-cross-sell-gallery-wrapper .cross-sell-gallery-image-wrapper${i} {
      left: 0;
      opacity: 1;
      display: block;
    }
    #${uniqueId}-input_${i}:checked ~ .mobile-cross-sell-gallery-wrapper .cross-sell-gallery-image-wrapper${(i + 1) % placeholderCrossSellGallerySize} {
      left: 175%;
      display: block;
      opacity: 0;
    }
    `;
    CSS.push(cssRules);
    if (placeholderGallery) {
      cssRules = `
      #${uniqueId}-input_${i}:checked ~ .cross-sell-gallery-link #cross-sell-gallery-item-description${(i + 2) % placeholderCrossSellGallerySize} {
        opacity: 1;
        transition-delay: 250ms;
      }
      `;
      CSS.push(cssRules);
    }
  }
  return CSS.join('').replace(/\s{2,}/g, '');
}
